import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as proposalContactLogService from '../../../../services/service/proposalContactLogService';
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link } from 'react-router-dom';
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import { Modal, Form } from "react-bootstrap";
import * as alert from "../../../../redux/alertSnackBarRedux";
import Flatpickr from "react-flatpickr";
import { formatToUSDate, getInputClasses } from "../../../../helpers/helper";
import constants from "../../../../constants/constants";
import TimeAgo from 'timeago-react';

const ProposalContactLogPage = (props) => {
    const { proposalId, showAlert, isReadOnly } = props;
    const [loading, setloading] = useState(false);
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const [contactLogModel, setContactLogModel] = useState({
        id: 0,
        proposalId: proposalId,
        description: '',
        followUpDate: '',
    });
    const [contactLogs, setContactLogs] = useState([]);
    const [contactInfo, setContactInfo] = useState({
        name: '',
        phone: '',
        email: ''
    });

    useEffect(() => {
        loadSavedLogs();
    }, []);

    const loadSavedLogs = () => {
        proposalContactLogService.GetProposalContactLogs(proposalId).then(res => {
            setContactLogs(res);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'warning' })
        })
    }

    const ContactLogsSchema = Yup.object().shape({
        id: Yup.number(),
        description: Yup.string().required("Please enter a log before you submit"),
        followUpDate: Yup.string().required("Please select a follow up date")
    });

    const SaveContactLog = (values, setSubmitting) => {
        setloading(true);
        proposalContactLogService.SaveProposalContactLog(values).then(res => {
            loadSavedLogs();
            formik.resetForm();
            showAlert({ message: res.message, variant: 'success' });
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(x => {
            setloading(false);
            setSubmitting(false);
        })
    }

    const formik = useFormik({
        initialValues: contactLogModel,
        validationSchema: ContactLogsSchema,
        enableReinitialize: true,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            SaveContactLog(values, setSubmitting);
        },
    });

    return (
        <>
            <Modal
                size="md"
                show={isContactModalOpen}
                centered
                onHide={() => setIsContactModalOpen(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Contact Information for <strong>{contactInfo.name}</strong>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p> Phone: <a href={`tel:${contactInfo.phone}`}> {contactInfo.phone}</a> </p>
                    <p>Email: <a href={`mailto:${contactInfo.email}`}> {contactInfo.email}</a> </p>
                </Modal.Body>
            </Modal>

            <form className="card card-custom" onSubmit={formik.handleSubmit}>
                {loading && <ModalProgressBar />}
                <div className="card-header py-3">
                    <div className="card-title align-items-start flex-column">
                        <h3 className="card-label font-weight-bolder text-dark">
                            Contact Logs
                        </h3>
                        <span className="text-muted font-weight-bold fz-xs mt-1">
                            View & Edit Contact Logs for this Proposal
                        </span>
                    </div>
                    {
                        !isReadOnly &&
                        <div className="card-toolbar">
                            <button
                                type="submit"
                                className="btn btn-success mr-2"
                                disabled={
                                    formik.isSubmitting || (formik.touched && !formik.isValid)
                                }
                            >
                                Add Log
                            {formik.isSubmitting}
                            </button>
                            <Link
                                to="/services/proposals"
                                className="btn btn-secondary"
                            >
                                Cancel
                            </Link>
                        </div>
                    }
                </div>
                <div className="form">
                    <div className="card-body">
                        {
                            !isReadOnly &&
                            <>
                                <div className="form-group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                        Follow Up Date
                                    </label>
                                    <div className="col-lg-9 col-xl-9">
                                        <Flatpickr
                                            placeholder="MM/DD/YYYY"
                                            options={{
                                                dateFormat: "m/d/Y"
                                            }}
                                            value={formatToUSDate(formik.getFieldProps("followUpDate").value)}
                                            onChange={date => {
                                                formik.setFieldValue("followUpDate", formatToUSDate(date[0]));
                                            }}
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "followUpDate")}`}
                                        />
                                        {formik.touched.followUpDate && formik.errors.followUpDate ? (
                                            <div className="invalid-feedback">
                                                {formik.errors.followUpDate}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                        Log
                                    </label>
                                    <div className="col-lg-9 col-xl-9">
                                        <Form.Control as="textarea" rows="10"
                                            placeholder="Start typing..."
                                            className={`form-control form-control-lg form-control-solid`}
                                            name="description"
                                            {...formik.getFieldProps("description")}
                                        />
                                        {formik.touched.Description && formik.errors.Description ? (
                                            <div className="invalid-feedback">
                                                {formik.errors.Description}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </>
                        }
                        <div className="form-group row pt-lg-10">
                            <div className="col-xl-3 col-lg-3">
                                <label className="col-form-label fz-mdsm fw-600">
                                    Contact Logs
                                </label>
                            </div>

                            <div className="col-xl-9 col-lg-9">
                                {
                                    contactLogs.length > 0 ?
                                        contactLogs.map(x =>
                                            <div key={x.id}>
                                                <div className="contact-log-block-container">
                                                    <div className="tc-user-block">
                                                        <div
                                                            className="img-block background-image-container"
                                                            style={{ backgroundImage: `url(${x.imageUrl ? (constants.API_URL + x.imageUrl) : ("/media/users/default.jpg")})` }}
                                                        >
                                                        </div>

                                                        <div className="user-info-block">
                                                            <Link
                                                                to={"/management/user-profile/" + x.userId}
                                                                className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg"
                                                            >
                                                                {x.name} | {x.role}
                                                            </Link>
                                                            <span className="text-muted font-weight-bold d-block">
                                                                <TimeAgo
                                                                    datetime={x.createdDate}
                                                                /> | {x.createdDate}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <p className="text-dark-100 m-0 pt-5 font-weight-bolder">
                                                        Follow Up Date: {x.followUpDate}
                                                    </p>
                                                    <button type="button" className="btn btn-info btn-sm mt-5" onClick={() => {
                                                        setContactInfo({ ...x });
                                                        setIsContactModalOpen(true);
                                                    }}>View User Contact</button>
                                                    <p className="text-dark-50 m-0 pt-5 font-weight-normal" style={{ whiteSpace: 'pre-line' }}>
                                                        {x.description}
                                                    </p>
                                                </div>
                                            </div>
                                        ) :
                                        <div className="contact-log-block-container">
                                            <div className="user-info-block">
                                                <a className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                                    No Contact Logs Available
                                                </a>
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}

export default connect(null, alert.actions)(ProposalContactLogPage);